import envReducer from "./env/reducers";
import sampleNodeReducer from "./sampleNode/reducers";
import solutionReducer from "./solution/reducers";

export default {
  env: envReducer,
  sampleNode: sampleNodeReducer,
  solution: solutionReducer,
};
